export default __webpack_public_path__ + "static/media/undraw_outer.679df65b.svg";